// Core
import { 
  Route, 
  Switch, 
  Redirect, 
  useRouteMatch, 
} from 'react-router-dom';

// Chakra imports
import { 
  Box,
} from '@chakra-ui/react';

// Components
import MarketPrice from './MarketPrice';
import MarketPriceEdit from './MarketPriceEdit';

function MarketPrices(props) {
  const { path } = useRouteMatch();

  return (
    <>
      <Box>
        <Switch>
          <Route path={`${path}/:id(new|\\d+)`} render={() => <MarketPriceEdit/>}/>
          <Route path={`${path}`} render={() => <MarketPrice/>}/>
          <Redirect from={`${path}*`} to={`${path}`} />
        </Switch>
      </Box>
    </>
  );
}

export default MarketPrices;